






import { Component, Vue } from 'vue-property-decorator';
import Users from '@/components/administration/Users.vue';

const namespace: string = 'users';

@Component({
    components: {
        Users,
    },
})
export default class AdministrationView extends Vue {}
